/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Policy_Rights_Access_LabelInputs */

const es_privacy_policy_rights_access_label = /** @type {(inputs: Privacy_Policy_Rights_Access_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acceso`)
};

const en_privacy_policy_rights_access_label = /** @type {(inputs: Privacy_Policy_Rights_Access_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Access`)
};

/**
* | output |
* | --- |
* | "Access" |
*
* @param {Privacy_Policy_Rights_Access_LabelInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const privacy_policy_rights_access_label = /** @type {((inputs?: Privacy_Policy_Rights_Access_LabelInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Policy_Rights_Access_LabelInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_privacy_policy_rights_access_label(inputs)
	return en_privacy_policy_rights_access_label(inputs)
});
export { privacy_policy_rights_access_label as "privacy_policy.rights.access_label" }